import { Stack } from '@mantine/core';
import { UnrecognisedAttendees } from 'src/meetings/detail/components/UnrecognisedAttendees';
import type { FamilyMeeting } from 'src/meetings/hooks/useScopedMeetings';
import type { MeetingScope } from 'src/meetings/scope';
import { MeetingAgendaCard } from './MeetingAgendaCard';
import type { MeetingOverview } from './meetingOverviews';
import { MeetingOverviewCard } from './MeetingOverviewCard';
import { ParticipantInfoCard } from './ParticipantInfoCard';

type ParticipantInfo = {
  id: string;
  firstName: string;
  name: string;
  address: string | null;
  email: string | null;
  phone: string | null;
};

type Props = {
  overviews: MeetingOverview[];
  participantInfo: ParticipantInfo[];
  scope: MeetingScope;
  meeting: FamilyMeeting;
  // Refreshes the meeting once an unrecognised attendee is linked to a new client.
  onAttendeeLinked: () => Promise<void> | void;
};

export function MeetingPreparation({
  overviews,
  participantInfo,
  scope,
  meeting,
  onAttendeeLinked,
}: Props) {
  return (
    <Stack gap="sm">
      {overviews.map(overview => (
        <MeetingOverviewCard
          key={overview.key}
          subject={overview.subject}
          title={`${overview.name} overview`}
        />
      ))}

      {participantInfo.map(participant => (
        <ParticipantInfoCard
          key={participant.id}
          name={participant.name}
          address={participant.address}
          email={participant.email}
          phone={participant.phone}
        />
      ))}

      <MeetingAgendaCard scope={scope} meeting={meeting} />

      <UnrecognisedAttendees event={meeting} onChanged={onAttendeeLinked} boxed />
    </Stack>
  );
}
